module.exports = __webpack_public_path__ + "img/IMGCeramic_0765.af989dd9.jpeg";